import React, { useState } from "react";
import { FaFacebook, FaTwitter, FaDribbble } from "react-icons/fa";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";
import "../Contactus/Talk.css";

const Talk = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    zip: "",
    option: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    phone: "",
    zip: "",
    option: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);  // Validate on each input change
  };

  const validate = (name, value) => {
    const errors = { ...formErrors };

    // Name validation (Only alphabets)
    if (name === "name") {
      const nameRegex = /^[A-Za-z\s]+$/;
      if (!value || !nameRegex.test(value)) {
        errors.name = "Name should contain only alphabets.";
      } else {
        errors.name = "";
      }
    }

    // Email validation
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !emailRegex.test(value)) {
        errors.email = "Invalid email address.";
      } else {
        errors.email = "";
      }
    }

    // Phone number validation (10 digits)
    if (name === "phone") {
      const phoneRegex = /^\d{10}$/;
      if (!value || !phoneRegex.test(value)) {
        errors.phone = "Phone number should be 10 digits.";
      } else {
        errors.phone = "";
      }
    }

    // Zip code validation (6 digits)
    if (name === "zip") {
      const zipRegex = /^\d{6}$/;
      if (!value || !zipRegex.test(value)) {
        errors.zip = "Zip code should be 6 digits.";
      } else {
        errors.zip = "";
      }
    }

    // Option selection validation
    if (name === "option") {
      if (!value) {
        errors.option = "Please choose an option.";
      } else {
        errors.option = "";
      }
    }

    // Message validation (at least 15 characters)
    if (name === "message") {
      if (!value || value.length < 15) {
        errors.message = "Message should be at least 15 characters.";
      } else {
        errors.message = "";
      }
    }

    setFormErrors(errors);  // Update form errors in state
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (Object.values(formErrors).every((err) => err === "")) {
      // Send email via email.js
      emailjs
        .sendForm("service_id", "template_id", e.target, "user_id")
        .then(
          (result) => {
            Swal.fire({
              title: "Success!",
              text: "Your message has been sent.",
              icon: "success",
              confirmButtonText: "OK",
            });
          },
          (error) => {
            Swal.fire({
              title: "Error!",
              text: "There was an error sending your message. Please try again.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        );
    } else {
      Swal.fire({
        title: "Error!",
        text: "Please fix the form errors before submitting.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="talk-container-tt">
      {/* Left Section */}
      <div className="left-section-tt">
        <h4 className="locations-heading-tt">LOCATIONS</h4>
        <h1 className="main-heading-tt">Let’s talk with expertise</h1>
        <p className="description-tt">
          Ultimately, the success of business is based on providing our customers
          with unparalleled product, service & support.
        </p>
        <div className="social-icons-tt">
          <div className="icon-tt">
            <div className="icon-div-tt">
              <FaFacebook />
            </div>
            <span>Facebook</span>
          </div>
          <div className="icon-tt">
            <div className="icon-div-tt">
              <FaTwitter />
            </div>
            <span>Twitter</span>
          </div>
          <div className="icon-tt">
            <div className="icon-div-tt">
              <FaDribbble />
            </div>
            <span>Dribbble</span>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="right-section-tt">
        <h2 className="form-heading-tt">Request an Estimate</h2>
        <form className="estimate-form-tt" onSubmit={handleSubmit}>
          <div className="form-row-tt">
            <div className="input-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your name"
              />
              {formErrors.name && <span className="error">{formErrors.name}</span>}
            </div>
            <div className="input-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email address"
              />
              {formErrors.email && <span className="error">{formErrors.email}</span>}
            </div>
          </div>
          <div className="form-row-tt">
            <div className="input-group">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Phone number"
              />
              {formErrors.phone && <span className="error">{formErrors.phone}</span>}
            </div>
            <div className="input-group">
              <input
                type="text"
                name="zip"
                value={formData.zip}
                onChange={handleInputChange}
                placeholder="Zip code"
              />
              {formErrors.zip && <span className="error">{formErrors.zip}</span>}
            </div>
          </div>
          <div className="input-group">
            <select
              name="option"
              value={formData.option}
              onChange={handleInputChange}
              className="dropdown-tt"
            >
              <option value="">—Please choose an option—</option>
              <option value="Option 1">Option 1</option>
              <option value="Option 2">Option 2</option>
            </select>
            {formErrors.option && <span className="error">{formErrors.option}</span>}
          </div>
          <div className="input-group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Your Message here"
            ></textarea>
            {formErrors.message && <span className="error">{formErrors.message}</span>}
          </div>
          <button type="submit" className="submit-btn-tt">
            Get Estimate
          </button>
        </form>
      </div>
    </div>
  );
};

export default Talk;
